import React, { useEffect } from 'react'
import { CodeEditor } from '@/features/code-editor'
import { MonacoEditorConfig } from '@/types'
import { useField } from 'formik'
import { PuffOverlay } from '@/components/ui/Loaders'
import { useQuery } from '@tanstack/react-query'
import { snippetsQueries } from '@/features/snippets'

export type SnippetEditorProps = {
  name: string
  snippetId: number | undefined
  config: MonacoEditorConfig
}

const SnippetEditor = ({ name, snippetId, config }: SnippetEditorProps) => {
  const [, { value }, { setValue }] = useField(name)
  const snippet = useQuery(snippetsQueries.detail(snippetId))

  useEffect(() => {
    if (snippet.data?.code === undefined) return
    setValue(snippet.data?.code)
  }, [snippet.data?.code])

  return snippet.isSuccess || snippetId === undefined ? (
    <CodeEditor config={config} initialValue={snippet.data?.code ?? value} theme={'snippet'} onModelChange={setValue} />
  ) : (
    <PuffOverlay />
  )
}

export default SnippetEditor
